/* eslint-disable max-len */
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import modelInverterActions from '@state/modelInverters/actions';
import devicesApi from '@api/devicesApi';

function useCreateModelInverters() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const dataInit = useSelector(({ modelInverters }) => modelInverters.createNewModelInverter);
  const idToEdit = useSelector(({ modelInverters }) => modelInverters.modelInverterIdToEdit);
  const [dataForm, setDataForm] = useState(dataInit);
  const abortC = new AbortController();
  const { signal } = abortC;
  // const body = useSelector(({ device: a }) => a.createNewDevice);
  const defaultData = {
    name: '',
    characteristics: {},
  };

  const onFinish = useCallback((values) => { // submit: create device or edit device

    if (!idToEdit) { //  create device

      devicesApi.createModelInverter({ signal, body: dataInit })
        .then((response) => {

          message.success(t('views.createModelInverter.form.createdSuccess'));
          setDataForm(defaultData);
          dispatch(modelInverterActions.setCreateEditModelsInverters(defaultData));
          dispatch(modelInverterActions.setModelsInvertersIdEdit(null));

          history.push('/dispositivos/administrar/model-inverters');

        })
        .catch((resError) => {

          message.error(t('views.createModelInverter.form.createdError'));

        });

    } else { // Edit Device

      devicesApi.editModelInverter({ signal, body: dataInit, id: idToEdit })
        .then((response) => {

          message.success(t('common.feedbacks.model_inverter_edit_success'));
          setDataForm(defaultData);
          dispatch(modelInverterActions.setCreateEditModelsInverters(defaultData));
          dispatch(modelInverterActions.setModelsInvertersIdEdit(null));
          history.push('/dispositivos/administrar/model-inverters');

        })
        .catch((resError) => {

          message.error(t('common.feedbacks.model_inverter_edit_failed'));
          // eslint-disable-next-line
          console.log(resError);

        });

    }

    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const formOnValuesChange = useCallback( // handle data
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);

      if (key[0] === 'name') {

        setDataForm({ ...dataForm, name: data[0] });
        dispatch(modelInverterActions.setCreateEditModelsInverters({ ...dataForm, name: data[0] }));

      } else {

        setDataForm({ ...dataForm, characteristics: { ...dataForm.characteristics, [key[0]]: data[0] } });
        dispatch(modelInverterActions.setCreateEditModelsInverters({ ...dataForm, characteristics: { ...dataForm.characteristics, [key[0]]: data[0] } }));

      }

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const cancelCreateEditDevice = useCallback(
    () => {

      history.push('/dispositivos/administrar/model-inverters');

    },
    // eslint-disable-next-line
    [],

  );

  useEffect(() => { // mount component

    if (!idToEdit) { // Validate is edit

      if (location.pathname === '/dispositivos/model-inverters/editar-model-inverter') {

        history.push('/dispositivos/model-inverters/crear-model-inverter');

      }

    }
    // return function cleanUp() {

    //   dispatch(firmwaresAction.setCreateEditFirmwares(defaultData));
    //   dispatch(firmwaresAction.setFirmwaresIdEdit(null));

    // };
  // eslint-disable-next-line
  }, [idToEdit]);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditDevice,
  };

}

export default useCreateModelInverters;
